// 商品详情加采购清单
;(function($) {
  var ProductInfoToCart = function(element, options) {
    var defaults = {
      data: [],
      buyNow: false,
      messages: {
        error_msg: 'Failed. please check the page'
      },
      gioIde:'', //gio标识符
      cartSuccessFn: $.noop
    };

    this.element = element;
    this.settings = $.extend({}, defaults, options);
    this.dataSrc = $(this.settings.data.join(','));
    this.init();
  };

  ProductInfoToCart.prototype = {
    init: function() {
      var self = this,
          settings = self.settings,
          $element = $(self.element);

      $(this.element).on('click', function(e) {
        if (settings.buyNow && !common.isLogin()) {
          common.gotoLogin();
        } else {
          self.ajax(settings, $(this), self);
        }
      })
    },
    ajax: function(settings, $element, self) {
      if ( !settings.data.length ) return;
      if ( settings.buyNow ) {
        self.dataSrc = $.param({uncheck_other: true}) + '&' + $.param($(settings.data.join(',')));
      } else {
        self.dataSrc = $(settings.data.join(','));
      }

      $.ajax({
        url: 'index.php?route=checkout/cart/add',
        type: 'post',
        data: self.dataSrc,
        dataType: 'json',
        beforeSend: function() {
          $element.button('loading');
          show_load();
        },
        complete: function() {
          $element.button('reset');

          if(settings.gioIde){
            gio('track', settings.gioIde, {
              'eshop_Productnumber_cms': common.getGIOValue('data-gio-product-type'),
              'eshop_productname_cms': common.getGIOValue('data-gio-product-name'),
              'eshop_addtoShoppingCart_No': common.getGIOValue('data-gio-product-num') || '1'
            });
          }

          hide_load();
        },
        success: function(json) {
          $('.alert-dismissible, .text-danger').remove();
          $('.form-group').removeClass('has-error');

          $('.right_list').removeClass('has_error');
          $('.text-danger').remove();

          if (json['error']) {
            if (json['error']['option']) {
              layer.msg(settings.messages.error_msg, {zIndex: 2147483647});
              for (var i in json['error']['option']) {
                var element = $('#input-option' + i.replace('_', '-'));

                if (element.parent().hasClass('input-group')) {
                  element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
                } else {
                  element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
                }
              }
            }

            $('.text-danger').parent().addClass('has-error');

            if (json['error']['flash_count']) {
              layer.msg(json['error']['flash_count'], {icon: 2, zIndex: 2147483647});
            }
            if (json['error']['services']) {
              layer.open({
                title:'提示',
                content:json['error']['services']
              });
              // layer.confirm(json['error']['services'],{icon: 2, title:"提示"}, function(){
              //   location.href = solution_host + '/services/guarantee'
              // });
            }
          }

          if (json['success']) {
            if (settings.cartSuccessFn.length) {settings.cartSuccessFn($element);}
            $('.cart-total').show();
            cart_ajax_load_html();

            if ( settings.buyNow ) {
              location = 'index.php?route=checkout/checkout';
            } else {
              layer.msg(json['success'], {zIndex: 2147483647, maxWidth: 400});
            }
          }
        }
      });
    },
  }

  $.fn.productInfoToCart = function (options) {
    this.each(function(index, el) {
      new ProductInfoToCart(this, options);
    });

    return this;
  };
})(jQuery);
